import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './arrow.module.scss'

// arrow icon
// size is the height and should be an even number in px
// all dimensions are em based on the size number
// the arrow aspect ratio can be adjusted per project in arrow.module.scss
// individual classes are added to allow for custom css transitions

const Arrow = ({
  className,
  barClassName,
  endTopClassName,
  endBottomClassName,
  direction,
  size,
}) => (
  <span
    className={classNames(styles.el, className)}
    style={{ fontSize: size }}
    data-direction={direction}
  >
    <span className={classNames(styles.el__bar, barClassName)} />
    <span className={classNames(styles.el__endTop, endTopClassName)} />
    <span className={classNames(styles.el__endBottom, endBottomClassName)} />
  </span>
)

Arrow.defaultProps = {
  className: '',
  barClassName: '',
  endTopClassName: '',
  endBottomClassName: '',
  size: '',
  direction: 'right',
}

Arrow.propTypes = {
  className: PropTypes.string,
  barClassName: PropTypes.string,
  endTopClassName: PropTypes.string,
  endBottomClassName: PropTypes.string,
  size: PropTypes.string,
  direction: PropTypes.oneOf(['right', 'left']),
}

export default Arrow
